<template>
  <TransitionRoot :show="open" as="template">
    <Dialog as="div" class="fixed z-10 inset-0 m-0.5 sm:m-4 md:mx-16 md:my-32 xl:mx-48 xl:my-36 2xl:mx-80 2xl:my-56" @close="$emit('close')">
      <div class="flex items-center justify-center p-4 text-center sm:block sm:p-0 h-full max-h-full">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                         leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-95 transition-opacity"/>
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <!--        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>-->
        <TransitionChild as="template" enter="ease-out duration-300"
                         enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                         enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                         leave-from="opacity-100 translate-y-0 sm:scale-100"
                         leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
              class="h-full flex flex-col bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle lg:w-1/2 mx-auto">

            <!-- Close button-->
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                  type="button"
                  @click="$emit('close')"
              >
                <span class="sr-only">Close</span>
                <XIcon aria-hidden="true" class="h-6 w-6"/>
              </button>
            </div>

            <!--header -->
            <div class="p-4 sm:px-6 flex-grow-0">
              <DialogTitle as="h3"
                           class="flex items-center space-x-2 text-lg font-medium leading-6 text-gray-900"
                           v-html="'Reject the company ' + (company!== null ? ` <strong class='pl-2'>${company.name}</strong>`: '')">
              </DialogTitle>
              <p class="text-sm text-gray-500 pb-2"></p>
              <div class="border-b border-gray"></div>
            </div>

            <!--body -->
            <div
                class="px-4 pb-5 sm:px-6 flex-grow h-full max-h-full overflow-y-auto xl:overflow-hidden flex flex-col">
              <!-- Content -->
              <div class="overflow-hidden overflow-y-auto mt-1">

                <main class="p-2 sm:py-3 sm:px-4">
                  <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
                    <!-- First step -->
                    <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">


                      <div>
                        <label class="text-base font-medium text-gray-900">Please, tell us about why you are rejecting
                          this Startup for your innovation</label>
                        <p class="text-sm leading-5 text-gray-500"></p>
                        <fieldset class="mt-4">
                          <legend class="sr-only">Reject reason</legend>
                          <div class="space-y-4">
                            <div v-for="choice in choices" :key="choice.id" class="flex items-center">
                              <input :id="choice.id"
                                     :checked="choice.id === reason"
                                     v-model="reason"
                                     :value="choice.id"
                                     name="reason"
                                     type="radio"
                                     class="focus:ring-primary focus:shadow-none h-4 w-4 text-primary-600 border-gray-300 active:border-primary"/>
                              <label :for="choice.id" class="ml-3 block text-sm font-medium text-gray-700">
                                {{ choice.title }}
                              </label>
                            </div>

                            <textarea :disabled="reason !== 'other'"
                                      v-model.trim="otherReason"
                                      :class="{'bg-gray-100': reason !== 'other'}"
                                      placeholder="Please tell us your reason so that we can improve our services"
                                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"/>
                          </div>
                        </fieldset>
                      </div>


                    </div>
                  </div>
                </main>


              </div>
              <!-- End Content -->
            </div>

            <!--footer -->
            <div class="p-4 sm:px-6 flex-grow-0 border-t ">
              <div class="flex items-end justify-end space-x-3 lg:space-x-6">
                <button
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
                    type="button"
                    @click="$emit('close')">
                  Cancel
                </button>
                <button
                    ref="addCompanyToListDoneButtonRef"
                    class="bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm"
                    type="button"
                    :class="{'cursor-default ': reason!==null, 'cursor-not-allowed ': reason===null}"
                    :disabled="reason===null"
                    @click="rejectHandle()">
                  Reject
                </button>
              </div>
            </div>

          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>

</template>

<script>

import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {XIcon} from "@heroicons/vue/outline";
import vSelect from "vue-select";

export default {
  name: "SimpleRejectCompanyDialog",
  emits: ['close'],
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    vSelect,
    XIcon,
  },
  props: {
    open: {
      type: Boolean,
      default: true,
    },
    channelUuid: {
      type: String,
      require: true
    },
    notRelevantChannelUuid: {
      type: String,
      require: true
    },
    company: {
      type: Object,
      require: true
    },
    choices: {
      type: Array,
      default() {
        return [
          {id: 'not-my-area', title: 'Not my technical area'},
          {id: 'not-our-focus', title: 'Not our focus domain'},
          {id: 'no-synergy', title: ' No synergy'},
          {id: 'competition-related', title: 'Competition-related reasons'},
          {id: 'other', title: 'Other reason'},
        ];
      }
    }
  },

  data() {
    return {
      reason: null,
      otherReason: null
    }
  },
  methods: {
    rejectHandle() {
      if (this.reason === null) {
        return;
      }

      let data = {
        rejectTypeName: 'sineora.v1',
        companySlug: this.company.id,
        channelUuid: this.channelUuid,
        reason: this.reason,
      };

      if (this.reason === 'other') {
        data['additionalInformation'] = {
          otherReason: this.otherReason
        }
      }

      this.$store
          .dispatch('createCompanyRejectVote', data)
          .then(function (response) {
            this.$store
                .dispatch('addCompanyToChannel', {company: this.company, channelUuid: this.notRelevantChannelUuid})
                .then(function () {
                  this.$emit('close')
                }.bind(this))
                .catch(function () {
                  this.$store
                      .dispatch('deleteCompanyRejectVote', {companyRejectVoteUuid: response.uuid})
                }.bind(this))


            let reason = '';
            if (this.reason === 'other') {
              reason += this.otherReason;
            } else {
              reason += (this.choices.find((n) => n.id === this.reason).title);
            }

            let message =
                `<p>I reject this company because:</p>\
                 <blockquote style="margin: 0.5rem 1rem; border-left: 3px solid #f28916; padding: 0.25rem 0.5rem;">\
                   ${reason.replace(/\n/gi, '<br/>')}\
                 </blockquote>`;

            this.$store
                .dispatch('createCompanyPost', {
                  channel: {uuid: this.channelUuid},
                  company: this.company,
                  content: message,
                })
          }.bind(this))
    }
  }
}
</script>

<style scoped>

</style>